var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0204 10.3265L9.87213 12.6949L14.9796 8.45318M11 1L1 4.44818V8.63991C1 14.0647 4.9525 18.95 11 21C17.0474 18.95 21 14.0647 21 8.63991V4.44818L11 1Z",
    stroke: "currentColor",
    strokeWidth: 1.11429,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyCheck);
export default __webpack_public_path__ + "static/media/verifyCheck.8863d188e9c5cf457aef5317001f8fb9.svg";
export { ForwardRef as ReactComponent };